import { HttpParams } from '@angular/common/http';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common.service';
import { DataService } from 'src/app/services/data.service';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { Router } from '@angular/router';
import {MemoryStorageService} from 'src/app/services/memory-storage.service';

@Component({
  selector: 'app-query-dashboard',
  templateUrl: './query-dashboard.component.html',
  styleUrls: ['./query-dashboard.component.css']
})
export class QueryDashboardComponent implements OnInit {

  frmQueryDashboard: FormGroup;

  lstFields = [];
  lstVendors = [];
  lstQueryRaisedFrom = [];
  lstQueryStatus = [];
  lstSearchData = [];
  lstLinkColumn = [];

  lstMessage = [];

  searchText: any;
  showFilter: boolean = true;
  showCloseIcon: boolean = false;
  recordCount: number;
  queryMessage = "";

  queryId: number;
  currrentUserId: Number;

  fileControlType = 'file';
  isCommentExpand: boolean = false;
  selectedFile = "";
  supportingFileName = "";
  supportingFileData = "";
  supportingFileType = "PDF";
  supportingFileSize = 10;

  modalReference_queryDetail: any;

  @ViewChild('queryDetail') ModalTemplate_queryDetail: TemplateRef<any>;

  constructor(private dataService: DataService, private commonService: CommonService,
    private modalService: NgbModal, private dialog: MatDialog, private router: Router,private memorystore: MemoryStorageService) {

  }

  ngOnInit(): void {
    // this.currrentUserId = Number(this.commonService.getUserInfoFromLocalStorage('userId'));
    this.currrentUserId = Number(this.memorystore.getItem('userId'));
    this.lstQueryStatus = [];
    this.lstQueryStatus.push({ id: 1, name: 'Open' });
    this.lstQueryStatus.push({ id: 2, name: 'Close' });

    this.lstQueryRaisedFrom = [];
    this.lstQueryRaisedFrom.push({ id: 'VP', name: 'Vendor Portal' });
    this.lstQueryRaisedFrom.push({ id: 'AP', name: 'Accounts Payable' });

    this.createFormField();

    this.lstLinkColumn = [];
    this.lstLinkColumn.push("query id");
    this.lstLinkColumn.push("action");
    this.lstLinkColumn.push("urn");
  }

  createFormField() {
    const formControls: any = {};

    formControls['invoiceNumber'] = new FormControl('', []);
    formControls['lastResponseDateTo'] = new FormControl('', []);
    formControls['queryRaisedFrom'] = new FormControl('', []);
    formControls['queryStatus'] = new FormControl('', []);
    formControls['paymentNumber'] = new FormControl('', []);
    formControls['urn'] = new FormControl('', []);

    this.frmQueryDashboard = new FormGroup(formControls);
  }

  get f() {
    return this.frmQueryDashboard.controls;
  }

  searchQuery() {
    this.lstSearchData = [];

    let body = {
      InvoiceNumber: this.frmQueryDashboard.get("invoiceNumber").value,
      PaymentNumber: this.frmQueryDashboard.get("paymentNumber").value,
      LastResponseDate: (this.frmQueryDashboard.get("lastResponseDateTo").value != '') ? this.commonService.dateFormating(this.frmQueryDashboard.get("lastResponseDateTo").value) : null,
      QueryRaisedFrom: this.frmQueryDashboard.get("queryRaisedFrom").value,
      QueryStatus: (this.frmQueryDashboard.get("queryStatus").value != '') ? Number(this.frmQueryDashboard.get("queryStatus").value) : 0,
      URN: this.frmQueryDashboard.get("urn").value,
      // ProjectId: Number(this.commonService.getUserInfoFromLocalStorage('projectId'))
      ProjectId: Number(this.memorystore.getItem('projectId'))
    };

    this.dataService.postData("querymanagement/searchquery", body).subscribe(res => {
      if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
        if (res.success == true) {
          this.lstSearchData = res.data;
          this.lstSearchData.forEach(row => {
            row['Query Raised Date'] = this.commonService.formatDate(new Date(row['Query Raised Date']), this.commonService.DateFormat);
            row['Action'] = ''
            if (row['Status'] == 'Open') {
              row['Action'] = 'Close';
            }
          });
          this.recordCount = this.lstSearchData.length;
          if (this.recordCount == 0) {
            this.commonService.showMessageBox("No record found.", "Message", "error");
          }
          else {
            this.showCloseIcon = true;
          }
        }
        else {
          if (res != null)
            this.commonService.showMessageBox(res.errorMessage, "Message", "error");
          else
            this.commonService.showMessageBox("Something went wront.", "error");
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      })
    //  err => {
    //   this.commonService.showMessageBox(err.toString());
    // });
  }

  reset() {
    this.lstSearchData = [];
    this.recordCount = this.lstSearchData.length;

    this.frmQueryDashboard.get('invoiceNumber').setValue('');
    this.frmQueryDashboard.get('lastResponseDateTo').setValue('');
    this.frmQueryDashboard.get('queryRaisedFrom').setValue('');
    this.frmQueryDashboard.get('queryStatus').setValue('');
    this.frmQueryDashboard.get('paymentNumber').setValue('');
    this.frmQueryDashboard.get('urn').setValue('');
  }

  gridCellClickEvent(edata) {
    if (edata.columnName == 'Query ID') {
      this.queryId = Number(edata.rowData['Query ID']);
      this.getQueryMessage();
    }
    else if (edata.columnName == 'Action') {
      if (edata.rowData.Action == 'Close') {
        let queryId = edata.rowData['Query ID']
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
          disableClose: true,
          data: {
            title: "Alert",
            message: "Are you sure you want to close this query?",
            messageBoxType: "question",
          },
        });
        dialogRef.afterClosed().subscribe((confirmed: boolean) => {
          if (confirmed) {
            let params = new HttpParams();
            params = params.append("queryId", queryId.toString());
            // params = params.append("closedBy", this.commonService.getUserInfoFromLocalStorage('userId'));
            params = params.append("closedBy", this.memorystore.getItem('userId'));
            params = params.append("closedDate", this.commonService.formatDate(new Date().toString(), "yyyy-MM-dd HH:mm:ss"));
            this.dataService.getData("QueryManagement/closequery", params).subscribe(res => {
              if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
                if (res.success == true) {
                  this.commonService.showMessageBox("Query/Dispute closed successfully.", "Message", "success");
                  this.searchQuery();
                }
              }
              else {
                if (res.errorCode != 0 && res.errorCode == 4000) {
                  this.router.navigateByUrl('/unauthorized');
                  return;
                }
                if (res.errorCode != 0 && res.errorCode == 3000) {
                  this.commonService.showMessageBox("Internal error")
                }
              }
            },
              error => {
                if (error.includes("401")) {
                  this.router.navigateByUrl('/unauthorized');
                  return;
                }
              });
          }
        });
      }
    }
  }

  showQueryDetailModal() {
    this.modalReference_queryDetail = this.modalService.open(this.ModalTemplate_queryDetail, {
      size: 'lg', centered: true, backdrop: true,
      keyboard: false
    });
  }

  closeQueryDetailModel() {
    this.queryMessage = '';
    this.isCommentExpand = false;
    this.supportingFileName = "";
    this.supportingFileData = "";
    this.modalReference_queryDetail.close()
  }

  sendQueryMessage() {

    if (this.queryMessage == undefined || this.queryMessage == '') {
      this.commonService.showMessageBox("Comments is required.", "Message", "error");
    }
    return;

    this.lstVendors = [];

    let request = {
      queryId: this.queryId,
      // userId: this.commonService.getUserInfoFromLocalStorage('userId'),
      userId: this.memorystore.getItem('userId'),
      message: this.queryMessage,
      messageDate: this.commonService.formatDate(new Date(), "yyyy-MM-ddTHH:mm:ss"),
      fileName: this.supportingFileName,
      fileData: this.supportingFileData
    }

    this.dataService.postData("querymanagement/addmessage", request).subscribe(res => {
      if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
        if (res != null && res.success == true) {
          this.closeQueryDetailModel();
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
  }

  getQueryMessage() {
    this.lstVendors = [];

    let params = new HttpParams();
    params = params.append("queryId", this.queryId.toString());
    this.dataService.getData("querymanagement/getmessage", params).subscribe(res => {
      if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
        if (res != null && res.success == true) {
          this.lstMessage = res.data;
          this.showQueryDetailModal();
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
  }

  onSelectSupportedFile(file) {

    if (file.target.files[0]) {
      this.supportingFileName = file.target.files[0].name;

      let reader = new FileReader();

      reader.onload = (e: any) => {
        this.supportingFileData = reader.result.toString();
      };

      reader.readAsDataURL(file.target.files[0]);

      this.selectedFile = '';
    }
  }

  deleteSupportedFile() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true,
      data: {
        title: "Alert",
        message: "Are you sure want to delete this file?",
        messageBoxType: "question",
      },
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.supportingFileName = "";
        this.supportingFileData = "";
      } else {
      }
    });
  }

  openAttachment(fileData) {
    let invoiceFileWindow = window.open('');
    invoiceFileWindow.document.write(
      `<style>body{margin:0;} iframe{border:none;}</style><iframe width='100%' height='100%' src='data:application/pdf;base64, ${encodeURI(
        fileData
      )}'></iframe>`
    );
  }
}
